import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { StructuredListing } from '@hz-design-system/web-ui';

import formatPrice from '../../utils/formatPrice';
import { getLargeImageUrl } from '../../utils/getImageUrls';
import { TFranchiseDealerItem } from 'types/TFranchiseDealersItem';

type TItemsProps = {
  item: TFranchiseDealerItem;
  className?: string;
  suppressZeroCents?: boolean;
};

const DealerItem = ({ item, className, suppressZeroCents }: TItemsProps) => {
  const { t } = useI18nContext();
  const imageUrl = item.picture?.url;
  const formattedImageUrl = imageUrl && imageUrl.trim() ? getLargeImageUrl(imageUrl, item.imageSizes) : '';

  return (
    <StructuredListing
      className={className}
      price={formatPrice(item.price, false, t, suppressZeroCents)}
      title={item.title}
      imageSrc={formattedImageUrl || ''}
      alt={`${item.title} ${t('sellerOtherItems.imageAltText')}`}
      imageLoading="lazy"
      decoding="async"
      isMaskedLink={item.thinContent}
      linkProps={{ href: item.url }}
    />
  );
};

export default DealerItem;
